import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import './Navbar.css';

const Navbar = () => {
    const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    return (
        <nav className="navbar">
            <div className="logo-container">
                <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: '1rem' }}>
                    <img src="/logo.svg" alt="KYUBURN Logo" className="logo" />
                    <span className="logo-text">KYUBURN</span>
                </Link>
            </div>

            <div className="nav-links">
                {!isAuthenticated ? (
                    <>
                        <button onClick={() => loginWithRedirect()} className="nav-link-btn">Login</button>
                        <button onClick={() => loginWithRedirect()} className="nav-cta">Get API Key</button>
                    </>
                ) : (
                    <div className="user-menu" ref={dropdownRef}>
                        <button className="user-btn" onClick={toggleDropdown}>
                            <span className="user-name">{user?.name || user?.email}</span>
                            <span className={`chevron ${isDropdownOpen ? 'open' : ''}`}>▼</span>
                        </button>

                        {isDropdownOpen && (
                            <div className="dropdown-menu">
                                <Link to="/profile" className="dropdown-item" onClick={() => setIsDropdownOpen(false)}>Profile</Link>
                                <Link to="/settings" className="dropdown-item" onClick={() => setIsDropdownOpen(false)}>Settings</Link>
                                <Link to="/my-apps" className="dropdown-item" onClick={() => setIsDropdownOpen(false)}>My Apps</Link>
                                <div className="dropdown-divider"></div>
                                <button onClick={handleLogout} className="dropdown-item logout-btn">
                                    Sign Out
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
